/* global grecaptcha */

import { Controller } from 'stimulus';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import toArray from '../helpers/toArray';

const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';

// Replace all non-letters from the id because it could cause issues when
// loading the ReCaptcha library...
const normalizeFormId = (id) => id.replace(/[^A-z]/g, '');

class FormValidationController extends Controller {
  connect() {
    this.formId = normalizeFormId(this.element.getAttribute('data-form-id'));

    if (this.reCaptchaElement()) {
      this.registerReCaptchaCallback();
      this.registerReCaptchaLoadCallback();
      this.loadReCaptcha();
    }

    porta({
      target: this.element,
      messages: nl,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
      },
      onError: (formElement) => {
        this.enableSubmitButton(formElement);
      },
      onValid: () => {
        this.enableSubmitButton(this.element);

        const recaptcha = this.reCaptchaElement();

        if (recaptcha) {
          grecaptcha.execute(recaptcha.getAttribute('data-widget-id'));
          return false;
        }

        return true;
      },
    });
  }

  reCaptchaElement() {
    return this.element.querySelector('.js-g-recaptcha');
  }

  registerReCaptchaCallback() {
    // Global function that will be called by ReCaptcha on valid captcha
    window[this.reCaptchaCallbackId()] = () => {
      this.element.submit();
    };

    // Define the callback name on the ReCaptcha element so the ReCaptcha library
    // knows what global function to call...
    this.reCaptchaElement().setAttribute('data-callback', this.reCaptchaCallbackId());
  }

  registerReCaptchaLoadCallback() {
    // Global function that will be called by ReCaptcha when its loaded
    window[this.reCaptchaLoadCallbackId()] = () => {
      const recaptchaContainer = this.reCaptchaElement();
      const id = grecaptcha.render(recaptchaContainer, {}, true);

      recaptchaContainer.setAttribute('data-widget-id', id);
    };
  }

  loadReCaptcha() {
    // Load ReCaptcha library
    const script = document.createElement('script');
    script.src = `${RECAPTCHA_URL}?onload=${this.reCaptchaLoadCallbackId()}`;
    document.head.appendChild(script);
  }

  reCaptchaCallbackId() {
    return `recaptchaCallback${this.formId}`;
  }

  reCaptchaLoadCallbackId() {
    return `recaptchaLoadCallback${this.formId}`;
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }
}

export default FormValidationController;
